<template>
  <div v-bind="$attrs" v-text="date" />
</template>

<script>
import { format, parseISO } from 'date-fns'

export default {
  name: 'AgDateText',
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    format: {
      type: String,
      required: true,
    },
  },
  computed: {
    date () {
      return format(parseISO(this.value), this.format)
    },
  },
}
</script>
